import { fetcher } from '../../configure'

export type PlannedRoute = {
    parseObj: any
    id: string
    routeName: string
    pins: [];
    totalDescent: number
    totalAscent: number
    routeLength: number
    guideId: string
    updatedAt: Date
    isNew: boolean
    isEdited: boolean
    isDeleted: boolean
    isEnabled: boolean
}

export type GetPlannedRoutesRequest = {
    guideId: string
}

export type GetPlannedRoutesResponse = {
	success: boolean
	routes: PlannedRoute[]
}

export type GetPlannedRoutesEndpoint = (
	request: GetPlannedRoutesRequest
) => Promise<GetPlannedRoutesResponse>

export const getPlannedRoutes: GetPlannedRoutesEndpoint = async (request) => {
	return await fetcher({
		method: 'get',
		path: `/users/planned-routes/${request.guideId}`,
		body: request, 
	})
}
